// import { usePrevious } from "~/hooks/usePrevious.ts";
// import formbricks from "@formbricks/js";
// import { usePostHog } from "posthog-js/react";

import type { Session, User } from "@acme/auth";
// import { useCallback, useRef } from "react";
import type { FunctionComponent, PropsWithChildren } from "react";
import { createContext, useEffect, useState } from "react";

import { authClient } from "~/features/auth/_utils/auth-client.js";
// type AuthStateChangeCallback = (event: "signin" | "signout") => void;
// type SubscribeToAuthStateChanges = (callback: AuthStateChangeCallback) => () => void;

// export type AuthContext = {
//   subscribeToAuthStateChanges: SubscribeToAuthStateChanges;
// } & (
//   | {
//       readonly isAuthenticated: true;
//       readonly session: Session;
//       readonly user: User;
//     }
//   | {
//       readonly isAuthenticated: false;
//       readonly session: null;
//       readonly user: null;
//     }
// );

export type AuthContext =
  | {
      readonly isAuthenticated: true;
      readonly session: Session;
      readonly user: User;
    }
  | {
      readonly isAuthenticated: false;
      readonly session: null;
      readonly user: null;
    };

export const AuthContext = createContext<AuthContext | null>(null);

interface AuthProviderProps {
  /** Set by AuthSessionGate after session load; first render is already definitive (no pending state). */
  readonly initialSession: Session | null;
}

export const AuthProvider: FunctionComponent<PropsWithChildren<AuthProviderProps>> = ({ children, initialSession }) => {
  // const posthog = usePostHog();
  const { data: sessionData } = authClient.useSession();
  const [session, setSession] = useState<Session | null>(initialSession);

  useEffect(() => {
    if (sessionData === undefined) {
      return;
    }
    setSession(sessionData);
  }, [sessionData]);

  let authContext: AuthContext;

  if (session) {
    authContext = {
      isAuthenticated: true,
      session,
      // subscribeToAuthStateChanges,
      user: session.user,
    };
  } else {
    authContext = {
      isAuthenticated: false,
      session: null,
      // subscribeToAuthStateChanges,
      user: null,
    };
  }

  // const { isAuthenticated } = authContext;
  // const wasAuthenticatedBefore = usePrevious(isAuthenticated);

  // useEffect(() =>
  // {
  //   if (wasAuthenticatedBefore && !isAuthenticated)
  //   {
  //     subscribersRef.current.forEach((callback) => callback("signout"));
  //   }
  //   else if (!wasAuthenticatedBefore && isAuthenticated)
  //   {
  //     subscribersRef.current.forEach((callback) => callback("signin"));
  //   }
  // }, [isAuthenticated, wasAuthenticatedBefore]);

  return <AuthContext.Provider value={authContext}>{children}</AuthContext.Provider>;
};
